export const transmisisonMapping = () => ({
  NEW: {
    decTypes: ['A', 'B', 'D', 'X'],
    entryStates: [
      'STATE_ENTRY_NONE',
      'STATE_ENTRY_IN_PROCESS',
      'STATE_ENTRY_READY',
      'STATE_ENTRY_ACCEPTED',
    ],
    circuits: null,
    NotCustomStates: ['STATE_TYPE_NOT_NEW', 'STATE_TYPE_NOT_FILED', 'STATE_TYPE_NOT_FAILED',
      'STATE_TYPE_DOC_NEW', 'STATE_TYPE_DOC_FILED', 'STATE_TYPE_DOC_FAILED',
      'STATE_TYPE_CER_NEW', 'STATE_TYPE_CER_FILED', 'STATE_TYPE_CER_FAILED',
      'STATE_TYPE_PRE_NEW', 'STATE_TYPE_PRE_FILED', 'STATE_TYPE_PRE_FAILED','STATE_RELEASED','CLEAR'],
  },
  CAN: {
    decTypes: null,
    entryStates: [
      'STATE_ENTRY_ACCEPTED',
      `STATE_ENTRY_AMEND_ACCEPTED`,
      'STATE_ENTRY_AMEND_REJECTED',
    ],
    circuits: null,
    NotCustomStates: [],
  },
  MOD: {
    decTypes: ['D', 'E', 'F'],
    entryStates: ['STATE_ENTRY_ACCEPTED'],
    circuits: null,
    NotCustomStates: [],
  },
  PRE: {
    decTypes: ['D', 'E', 'F'],
    entryStates: [
      'STATE_ENTRY_ACCEPTED',
      `STATE_ENTRY_AMEND_ACCEPTED`,
      `STATE_ENTRY_AMEND_REJECTED`,
    ],
    circuits: null,
    NotCustomStates: [],
  },
  DOC: {
    decTypes: ['A', 'B', 'C'],
    entryStates: ['STATE_ENTRY_ACCEPTED', `STATE_ENTRY_AMEND_ACCEPTED`],
    circuits: ['red', 'yellow', 'orange'],
    NotCustomStates: [],
  },
  CER: {
    decTypes: ['A'],
    entryStates: ['STATE_ENTRY_ACCEPTED'],
    circuits: null,
    NotCustomStates: [],
  },
  NOT: {
    decTypes: null,
    entryStates: ['STATE_ENTRY_ACCEPTED', `STATE_ENTRY_AMEND_ACCEPTED`],
    circuits: null,
    NotCustomStates: [],
  },
})